module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#proofread",
      toString: function () {
        return this.url;
      }
    }